// import store from '@/store'

export const mixinSquare = {
  computed: {

  }
}
